import React from "react";
import { Link } from "react-router-dom";
import "./DemoButton.css";

export default function DemoButton({
  to = "/Contact",
  onClick,
  children = "Get a demo",
  className = "",
  as = "link",
}) {
  const classes = `demo-btn demo-btn--primary ${className}`.trim();

  if (as === "button" || onClick) {
    return (
      <button type="button" className={classes} onClick={onClick}>
        {children}
      </button>
    );
  }

  return (
    <Link className={classes} to={to}>
      {children}
    </Link>
  );
}
